// get tab containers
const tabContainers = document.querySelectorAll('.js-tab');

// setup tabs
const setupTabs = (tabContainer) => {
    const tabs = tabContainer.querySelectorAll('.js-tab-btn');
    const items = tabContainer.querySelectorAll('.js-tab-content');

    tabs.forEach((tab) => {
        tab.onclick = () => {
            const target = tab.getAttribute('aria-controls');
            const content = document.getElementById(target);

            // toggle button active class
            tabs.forEach((btn) => {
                btn.classList.remove('border-orange', 'bg-orange', 'text-cream');
            });
            tab.classList.add('border-orange', 'bg-orange', 'text-cream');

            // toggle content active class
            items.forEach((item) => {
                item.classList.remove('is-active');
            });
            content.classList.add('is-active');
        };
    });
};

const init = () => {
    if (tabContainers.length === 0) return;

    // init tabs
    tabContainers.forEach((tabContainer) => {
        // setup tabs
        setupTabs(tabContainer);
    });
};

export default init;
